import React, { useState } from "react";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import logo from "../assets/pymble-p.png";
import "./Toast.css";

type EventToastVariant = "success" | "error";

interface EventToastProps {
	title: string;
	message: string;
	delay: number;
	show: boolean;
	variant?: EventToastVariant;
}

export const EventToast: React.FC<EventToastProps> = ({
	title,
	message,
	delay,
	show,
	variant = "success",
}) => {
	const [showToast, setShowToast] = useState(show);
	const toggleShowToast = () => setShowToast(!showToast);

	const bg = variant === "error" ? "danger" : undefined;

	return (
		<ToastContainer position={"top-end"} className="p-3">
			<Toast
				show={show}
				onClose={toggleShowToast}
				delay={delay}
				autohide
				bg={bg}
			>
				<Toast.Header>
					<img src={logo} className="rounded me-2 toastLogo" alt="" />
					<strong className="me-auto">{title}</strong>
				</Toast.Header>
				<Toast.Body
					className={variant === "error" ? "text-white" : undefined}
				>
					{message}
				</Toast.Body>
			</Toast>
		</ToastContainer>
	);
};
